import initialState from './initialState';
import * as storeConstants from '../store/constants';
import { GET_REQUIREMENTS_TAGS } from '../actions/actionTypes';
import fallbackRequirementTags from './fallbackRequirementsTags';

const reducer = (state = initialState[storeConstants.REQUIREMENTS_TAGS], action) => {
  switch (action.type) {
    case GET_REQUIREMENTS_TAGS.SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case GET_REQUIREMENTS_TAGS.FAILURE: {
      return {
        ...state,
        ...fallbackRequirementTags
      };
    }
    default:
      return state;
  }
};

export default reducer;
